import BaseComponent from "../../baseComponent.js";
import Input from "./input.jsx";
import Output from "./output.jsx";
import Variable from "./variable.jsx";
import FormulaBar from "./formulaBar.jsx";
import Header from "./header.jsx";
import Empty from "./empty.jsx";
import DatasetService from "../../../core/services/datasetService.js";
import DataStore from "../../../core/stores/dataStore.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
import UniqueIdGenerator from "../../../core/utils/uniqueIdGenerator.js";
import styles from "./spreadsheet.scss";

require('./functions/functions.js');
const DataService = require("../../../core/services/data-service/data-service.js");

export default class Spreadsheet extends BaseComponent {
  constructor(props) {
    super(props);
    var inputs = this.props.model.inputs || {};
    var globalVariables = this.props.globalVariables;
    var localVariables = this.props.localVariables;
    var output = this.props.model.output || null;

    if (!globalVariables) {
      globalVariables = {
        datasetId: "00000000-0000-0000-0000-00000000",
        name: "GLOBAL VARIABLES",
        fields: {},
        color: "#7F0C73",
        datasetRef: "GLOBAL"
      };
    }

    if (!localVariables) {
      localVariables = {
        datasetId: "00000000-0000-0000-0000-00000000",
        name: "OUTPUT",
        fields: {},
        color: "#1f77b4",
        datasetRef: "OUTPUT"
      };
    }

    this.state = {
      inputs: inputs,
      globalVariables: globalVariables,
      localVariables: localVariables,
      output: output,
      formula: {
        type: null,
        datasetRefId: null,
        fieldId: null,
        value: null
      }
    };
  }

  componentWillMount() {
    this.datasetRefMap = {};
    this.defaultColors = [
      '#ff7f0e', '#2ca02c', '#d62728', '#8c564b',
      '#e377c2', '#7f7f7f', '#bcbd22', '#17becf',
      '#43C2FF', '#BCFF7B', '#7F0C73', '#7F6A0C', '#9467bd'];
    this.selectColors = [
      '#F44336', '#673AB7',
      '#03A9F4', '#4CAF50', '#E91E63', '#FDD835', '#FF5722', '#795548',
      '#FFC107', '#8BC34A', '#00BCD4', '#3F51B5', '#E91E63', '#9C27B0',
      '#2196F3', '#009688', '#FF9800'
    ];
    this.selectedCells = [];
    this.dynamicFunctions = {
      output: {},
      global: {}
    };
    this.cachedValueDOMs = {};

    // cell clicking behavior indicators
    this.insertArgumentMode = false;

    this.selectedCell = null;
    this.ops = "+-*/^%(),";
  }

  changeInsertMode(mode) {
    this.insertArgumentMode = mode;
  }

  getUnusedColor() {
    var colors = this.defaultColors.slice();
    for (var datasetRef in this.state.inputs) {
      var index = colors.indexOf(this.state.inputs[datasetRef].color);
      if (index > -1) colors.splice(index, 1);
    }

    return colors[0];
  }

  evaluateFormula(formula) {
    var toEvaluate = "", result = "";
    var propsToSearch = ["inputs", "output", "globalVariables", "localVariables"];

    for (var i = 0; i < formula.length; i++) {
      let f = formula[i];
      if(typeof window[f.toLowerCase()] === "function") {
        f = f.toLowerCase();
      }
      if (f.trim() === "=") continue;
      if (f.indexOf(".") > -1 && f.length >= 3) {
        if (!isNaN(parseFloat(f))) {
          toEvaluate += f;
          result += f;
          continue;
        }
        var dataset = f.split(".")[0].trim();
        var fieldId = f.split(".")[1].trim();
        for (var j = 0; j < propsToSearch.length; j++) {
          var ref = "this.state['" + propsToSearch[j] + "']['" + dataset + "'].fields['" + fieldId + "'].value";
          try {
            eval(ref);
            toEvaluate += ref;
            result += propsToSearch[j] + "['" + dataset + "'].fields['" + fieldId + "'].value";
            break;
          } catch (e) {
          }
        }

      } else {
        var openOps = this.ops.slice().replace(")", "");
        if (openOps.indexOf(f.trim()) > -1 && i === formula.length - 1) break;
        toEvaluate += f;
        result += f;
      }
    }

    if (toEvaluate != "") {
      try {
        var t = eval(toEvaluate);
        if ((t !== null && typeof t !== "number") || isNaN(t)) {
          return "ERROR";
        }
        return "return " + result;
      } catch (e) {
        return "ERROR";
      }
    }

    return "ERROR";
  }

  componentDidMount() {
    var _this = this;
    this.datasetIds = [];
    this.outputRef = Object.keys(this.state.output)[0];
    for (var datasetRef in this.state.inputs) {
      this.datasetIds.push(this.state.inputs[datasetRef].datasetId);
      this.datasetRefMap[this.state.inputs[datasetRef].datasetId] = datasetRef;
      this.handleUpdate({dataset: this.state.inputs[datasetRef].datasetId});
    }
    this.requestData(this.datasetIds);

    // $(this.refs.spreadsheet).find("td.spreadsheet-selectable").on("click", this.handleClick);

    init(this.state.output[this.outputRef]);
    this.handleUpdate();
    // TODO: temp
    function init(output) {
      for (var fieldId in output.fields) {
        var formula = output.fields[fieldId].formula;
        if (formula) {
          var parsedFormula = _this.parseRawFormula(output.fields[fieldId].formula);
          var evaluatedResult = _this.evaluateFormula(parsedFormula);
          if (evaluatedResult !== "ERROR") {
            _this.dynamicFunctions["output"][fieldId] = new Function("inputs", "output", "global", evaluatedResult);
          }
        }
      }
    }
  }

  componentWillUnmount() {
    this.unsubscribeAll();
  }

  handleDrop(dataset) {
    var _this = this;
    DatasetService.getDataProfileById(dataset.dataProfile, function (response) {
      var newDataset = {
        datasetId: dataset.persistenceId,
        name: dataset.name,
        fields: {},
        color: _this.getUnusedColor()
      };
      var reference = dataset.name.split(" ")[0];
      for (var i = 0; i < response.data[0].fields.length; i++) {
        var fieldId = response.data[0].fields[i].fieldId;
        newDataset.fields[fieldId] = {
          value: null
        }
      }
      _this.datasetRefMap[dataset.persistenceId] = reference;
      _this.state.inputs[reference] = newDataset;
      _this.setState({
        inputs: _this.state.inputs
      });

      _this.requestData([dataset.persistenceId]);

    });
  }

  addOrReplaceOutput(dataset) {
    var _this = this;
    if (dataset.persistenceId !== this.state.output[this.outputRef].datasetId) {
      DatasetService.getDataProfileById(dataset.dataProfile, function (response) {
        var reference = "OUTPUT";
        var newOutputDataset = {
          datasetId: dataset.persistenceId,
          name: dataset.name,
          fields: {},
          color: "#9467bd",
          datasetRef: reference
        };
        for (var i = 0; i < response.data[0].fields.length; i++) {
          var fieldId = response.data[0].fields[i].fieldId;
          newOutputDataset.fields[fieldId] = {
            value: null,
            formula: null
          }
        }
        _this.datasetRefMap[dataset.persistenceId] = reference;
        _this.setState({
          output: newOutputDataset
        });
      });
    }
  }

  handleUpdate(data) {
    var _this = this;
    var shouldPublishFakeData = false;
    // update component state and dom
    var d = DataStore.get("77ea8bb0-9f53-11e5-9206-e6d22ac3494e");
    if (data) {
      var ref = this.datasetRefMap[data.dataset];
      var fieldIds = Object.keys(data);
      for (var i = 0; i < fieldIds.length; i++) {
        if (this.state.inputs[ref].fields.hasOwnProperty(fieldIds[i])) {
          this.state.inputs[ref].fields[fieldIds[i]].value = data[fieldIds[i]];
          this.updateDOM(data.dataset, ref, fieldIds[i], data[fieldIds[i]])
        }
      }

      // TODO: remove temp code
      if (this.props.model.id == "HvimdJQCqsPoHMXKnWLwvFTKuaxpAjKXlFA") {
        this.publishFakeData(this.state.inputs[ref]);
      }
    }

    // execute formula if exists
    for (var fieldId in this.state.output[this.outputRef].fields) {
      var fn = this.dynamicFunctions["output"][fieldId];
      if (fn) {
        try {
          var evaluatedResult = fn(this.state.inputs, this.state.output, this.state.global);
          evaluatedResult = Math.round(evaluatedResult * 100000) / 100000;
          this.updateDOM(this.state.output[this.outputRef].datasetId, this.state.output[this.outputRef].datasetRef, fieldId, evaluatedResult);
          this.state.output[this.outputRef].fields[fieldId].value = evaluatedResult;
        } catch (e) {
          console.debug(e);
        }
      } else {
        this.updateDOM(this.state.output[this.outputRef].datasetId, this.state.output[this.outputRef].datasetRef, fieldId, null);
      }
    }

    this.publishFakeData(this.state.output[this.outputRef]);
  }

  publishFakeData(output) {
    var data = {
      dataset: output.datasetId,
      context: output.datasetId,
      timestamp: new Date().getTime() / 1000
    };
    for (var fieldId in output.fields) {
      data[fieldId] = output.fields[fieldId].value;
    }

    DataStore.store(data.dataset, data);
    this.publish(data.dataset, data);
  }

  updateDOM(datasetId, datasetRefId, fieldId, value) {
    if (!this.cachedValueDOMs[datasetId]) {
      this.cachedValueDOMs[datasetId] = {};
    }

    if (this.cachedValueDOMs[datasetId].hasOwnProperty(fieldId)) {
      this.cachedValueDOMs[datasetId][fieldId].textContent = value;
    } else {
      var dom = document.getElementById(datasetRefId + "." + fieldId).children[0];
      dom.textContent = value;
      this.cachedValueDOMs[datasetId][fieldId] = dom;
    }
  }

  requestData(datasetIds) {
    var payload = [];
    for (var i = 0; i < datasetIds.length; i++) {
      var tempData = {
        datasetId: datasetIds[i],
        parameters: {},
        mappings: {}
      };
      tempData.mappings[i] = {
        datasetId: datasetIds[i]
      };
      payload.push(tempData);

      // TODO: remove temp code
      if (this.props.model.id !== "HvimdJQCqsPoHMXKnWLwvFTKuaxpAjKXlFA") {
        this.subscribe(datasetIds[i], this.handleUpdate);
      }
    }
    DataService.subscribe(payload);
  }

  changeCurrentFormula(type, datasetRefId, fieldId) {
    if (this.insertArgumentMode) {
      var text = datasetRefId + "." + fieldId;
      this.publish(InternalEvent.Studio.SPREADSHEET_CELL_CLICKED, text);
    } else if (type === "OUTPUT") {
      this.setState({
        formula: {
          type: type.toLowerCase(),
          datasetRefId: datasetRefId,
          fieldId: fieldId,
          value: this.state.output[this.outputRef].fields[fieldId].formula
        }
      });

      this.highlightSelectedCellBorder(datasetRefId, fieldId);

    } else {
      this.resetFormulaBar();
    }
  }

  resetFormulaBar() {
    this.setState({
      formula: {
        type: null,
        datasetRefId: null,
        fieldId: null,
        value: null
      }
    });
  }

  handleInputCellClick(datasetRefId, fieldId) {
    if (this.insertArgumentMode && datasetRefId && fieldId) {
      var text = datasetRefId + "." + fieldId;
      this.publish(InternalEvent.Studio.SPREADSHEET_CELL_CLICKED, text);
    } else {
      this.resetFormulaBar();
      this.highlightSelectedCellBorder(datasetRefId, fieldId);
    }
  }

  highlightSelectedCellBorder(datasetRefId, fieldId) {
    if (this.selectedCell) {
      this.selectedCell.classList.remove("selected");
      this.selectedCell = null;
    }

    var cell = document.getElementById(datasetRefId + "." + fieldId);
    if (cell) {
      cell.childNodes[1].classList.add("selected");
      this.selectedCell = cell.childNodes[1];
    }
  }

  updateFormula(formula, ignoreStateUpdate, resetFormula) {
    ignoreStateUpdate = ignoreStateUpdate || false;
    resetFormula = resetFormula || false;
    var type = this.state.formula.type;
    var fieldId = this.state.formula.fieldId;
    var datasetRefId = this.state.formula.datasetRefId;
    var parsedFormula = this.parseRawFormula(formula);
    var evaluatedResult = this.evaluateFormula(parsedFormula);

    // manually update output dataset. Don't need setState
    this.state.output[this.outputRef].fields[fieldId].formula = formula;

    if (resetFormula) {
      this.changeCurrentFormula();
    } else if (!ignoreStateUpdate) {
      this.setState({
        formula: {
          type: type,
          datasetRefId: datasetRefId,
          fieldId: fieldId,
          value: formula
        }
      });
    }

    if (parsedFormula.length === 0) {
      this.updateDOM(this.state.output[this.outputRef].datasetId, this.state.output[this.outputRef].datasetRef, fieldId, null);
    } else if (evaluatedResult !== "ERROR") {
      this.dynamicFunctions[type][fieldId] = new Function("inputs", "output", "global", evaluatedResult);
      this.handleUpdate();
    } else {
      delete this.dynamicFunctions[type][fieldId];
    }
  }

  parseRawFormula(text) {
    var regex = /([\=\+\-\*\/\(\)\,])/;
    return text.split(regex).filter(function (str) {
      return /\S/.test(str);
    });
  }

  createMapping(type, datasetId, fieldId) {
    let formula;
    let mappedFormula = "";
    let mappings = {};

    if (type === "OUTPUT") {
      formula = this.state.output[this.outputRef].fields[fieldId].formula;
    } else if (type === "INPUT") {
      formula = this.state.input[this.inputRef].fields[fieldId].formula;
    }

    if (formula) {
      let parsedFormula = this.parseRawFormula(formula);
      parsedFormula.map(part => {
        if (part.indexOf(".") > -1 && part.length >= 3) {
          let dataset = part.split(".")[0].trim();
          let field = part.split(".")[1].trim();

          if (this.state.inputs.hasOwnProperty(dataset) && this.state.inputs[dataset].fields.hasOwnProperty(field)) {
            let key = UniqueIdGenerator.id();
            mappings[key] = {
              datasetId: this.state.inputs[dataset].datasetId,
              fieldId: field,
              value: part
            };
            mappedFormula += key;
          } else {
            mappedFormula += part;
          }
        } else {
          mappedFormula += part;
        }
      });
    }

    return {
      formula: mappedFormula,
      mappings: mappings
    }
  }

  render() {
    var inputs = [];

    var numRows = 10;
    for (var datasetRef in this.state.inputs) {
      var sum = 0;
      var fieldIds = Object.keys(this.state.inputs[datasetRef].fields);
      for (var j = 0; j < fieldIds.length; j++) {
        var fieldId = fieldIds[j];
        if (this.state.inputs[datasetRef].fields[fieldId]) sum++;
      }
      if (sum > numRows) numRows = sum;
    }

    var key = 0;
    for (var datasetRef in this.state.inputs) {
      inputs.push(<Input
        onCellClicked={this.handleInputCellClick}
        onValueChange={this.handleUpdate}
        numRows={numRows}
        datasetRef={datasetRef}
        datasetInputModel={this.state.inputs[datasetRef]}
        key={key++}
      />);
    }

    var outputRef = Object.keys(this.state.output)[0];

    return (
      <div className="studio-spreadsheet" style={{background: "white"}}>
        <FormulaBar formula={this.state.formula}
                    updateFormula={this.updateFormula}
                    eval={this.evaluateFormula}
                    changeInsertMode={this.changeInsertMode}
                    colors={this.selectColors}/>
        <Header inputs={this.state.inputs}
                output={this.state.output[outputRef]}
                localVariables={this.state.localVariables}
                globalVariables={this.state.globalVariables}/>
        <div className="studio-spreadsheet__datasets" ref="spreadsheet">
          {inputs}
          <Empty numRows={numRows} handleDrop={this.handleDrop}/>
          <Variable numRows={numRows}
                    variableModel={this.state.localVariables}
                    changeCurrentFormula={this.changeCurrentFormula}
                    updateFormula={this.updateFormula}/>

          <Variable numRows={numRows}
                    variableModel={this.state.globalVariables}
                    changeCurrentFormula={this.changeCurrentFormula}
                    updateFormula={this.updateFormula}/>

          <Output numRows={numRows}
                  datasetOutputModel={this.state.output[outputRef]}
                  changeCurrentFormula={this.changeCurrentFormula}
                  updateFormula={this.updateFormula}
                  handleOutputDrop={this.addOrReplaceOutput}
                  createMapping={this.createMapping}/>
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/analytic-studio/spreadsheet/spreadsheet.jsx